
<template>
  <div>
    <div :class="['rows', {'show-projects': shouldShowProjects}]">
      <!-- <ProjectRow
        v-for   ="(project, rIndex) in projectsMeta"
        v-bind  ="project"
        :key    ="project.title + rIndex"
        :style="{transition: `opacity 333ms ease-in ${rIndex * 111}ms, transform 333ms ease-in ${rIndex * 111}ms`}"
        @content-loaded="onLoad"
      /> -->
      <div class="project" v-for="illo in illustrations" :key="illo.img.src">
        <div class="col text-col" v-if="illo.title">
          <h2 class="detail project-title text-subtitle">{{title}}</h2>
        </div>
        <div class="col image-col">
          <ResponsiveImage 
            v-if="illo.img" 
            v-bind="illo.img" 
            :isResponsive="true"
            sizes="(max-width: 768) 90vw, 20vw" 
          />
        </div>
      </div>
      <!-- <transition name="fade">
        <div class="modal" v-if="true">
          <div class="modal__background" @click="modal_image = false"/>
          <ResponsiveImage 
            v-bind="modal_image"
            :isResponsive="true"
            sizes="80vw" 
          />
        </div>
      </transition> -->
    </div>
  </div>
</template>
<script>
import ResponsiveImage from '../components/ResponsiveImage.vue';

export default {
  name: 'Overview',
  components: {
    ResponsiveImage,
  },
  props: ['siteMeta', 'projectsMeta'],
  data() {
    return {
      modal_image: false, 
      loadedProjects: 0,
      delayed: false, 
      illustrations: [
        {
          img: {
            ext: ".jpg",
            src: "/uploads/c4a580165f984a93a62b12bfd1249ace.jpg"
          }
        },
        {
          img: {
            ext: ".jpg",
            src: "/uploads/54c5ef350b7148bda79882f2026f5306.jpg"
          }
        },
       
        {
          img: {
            ext: ".jpg",
            src: '/uploads/flowers-card.jpg'
          }
        },
        {
          img: {
            ext: ".jpg",
            src: '/uploads/shrines-1.jpg'
          }
        },
        {
          img: {
            ext: ".jpg",
            src: '/uploads/extinct.jpg'
          }
        },
        {
          img: {
            ext: ".jpg",
            src: "/uploads/sushi.jpg"
          }
        },
        {
          img: {
            ext: ".jpg",
            src: '/uploads/shrine-2.jpg'
          }
        },
        {
          img: {
            ext: ".jpg",
            src: "/uploads/cc01b89cc908409c93fea5d460ab6a4e.jpg"
          }
        },
        {
          img: {
            ext: ".jpg",
            src: '/uploads/shed-logo.jpg'
          }
        },
      ]
    }
  },
	computed: {
    shouldShowProjects() { 
      return this.delayed || (this.loadedProjects >= this.projectsMeta.length) || this.delayed;
    }
  },
  methods: {
    onLoad() {
      this.loadedProjects += 1;   
    }
  },
  mounted() {    
    setTimeout(() => {
      this.delayed = true; 
    }, 100);
  }
}
</script>

<style lang="sass" scoped>
@import '../assets/partials/_vars'

.modal
  width: 100%
  height: 100%
  position: fixed
  top: 0
  left: 0
  z-index: 10
  display: flex

  .modal__background
    position: absolute
    width: 100%
    height: 100%
    top: 0
    left: 0

.name
  font-size: 1.4rem
  letter-spacing: 0.01em
  font-weight: 400
  text-transform: uppercase
  margin-bottom: 1rem

.header
  margin-top: 10rem
  color: $primary-color
  margin-bottom: 15rem

.recent
  display: block
  margin-bottom: 3rem

.rows
  display: flex
  flex-wrap: wrap
  flex-direction: column
  position: relative
  padding-bottom: 5rem
  .project
    opacity: 0
    transform: translateY(5px)
  &.show-projects
    .project
      opacity: 1
      transform: translateY(0px)

.copyright
  display: block
  width: 100%
  color: #555 // $tertiary-color
  font-weight: 100
  text-align: right
  padding: 2rem 0

+after-bg-mobile
  .rows
    display: grid
    grid-template-columns: repeat(2, minmax(0, 1fr)) 
    column-gap: 1/28 * 100vw
    width: 100%
    padding: 0
    z-index: 20

  .header
    margin-top: 0

+after-sm-desktop
  .header
    width: 6/8 * 100vw

  .copyright
    padding: 2rem 1/28 * 100vw
    display: none

</style>
